import { FC } from 'react';
import { useTranslation } from '@nextgen-web-framework/all';
import { formatNumber } from '@nextgen-web-framework/core';
import TotalAmountPropTypes from './types/propTypes';
import styles from './TotalAmount.module.scss';

const TotalAmount: FC<TotalAmountPropTypes> = ({ amount, paymentMethodId }: TotalAmountPropTypes) => {
  const t = useTranslation();
  return (
    <div className={styles['total-container']}>
      <div className={styles['count-container']} data-testid="amount">
        {formatNumber(amount ?? 0)}
      </div>
      <p className={styles['balance-text']} data-testid="amount-text">
        {t(`payment.accountHistory.totalbalance_${paymentMethodId}`)}
      </p>
    </div>
  );
};

export default TotalAmount;
